module.exports = {
	colors: {
		main: '#3f51b5',
		sec: '#ff4081',
		alt: '#3f51b5',
	},

	showFunds: false,
	showBuses: false,
	showHomeworks: true,
	useCourses: false,

	about: {
		mobiles: ['0944416140', '0953419672'],
		phones: [],
		address: 'حلب الجديدة - جانب دوار الشفاء',
		data: [0, 0],
		email: null,
		facebook: 'https://www.facebook.com/alawal.institute.aleppo',
		privacy: 'https://alnukhbeh-edu.com/privacy-policy/',
		details: [
			{
				title: 'أسرة الأول التعليمية',
				content: [
					'أن نكونَ مركزاً فريداً رائداً في إعداد وتهيئةِ جيلٍ جَديدٍ قادرٍ على الابتكارِ والابداعِ، وقيادة مجتمعهم نحو التغيير الإيجابي والتميّز في الأداء، نعتمدُ بذلك مفهومَ التنميةِ البشريّةِ بخبراتٍ وتقنيّات متطوّرة، لطاقات طلابنا ضمنَ بيئةٍ مُحفزّة للتعلّم والإبداعِ الفكري',
				],
			},
		],
	},

	pwa: {
		name: 'أسرة الأول التعليمية',
		shortName: 'أسرة الأول التعليمية',
		description: 'أسرة الأول التعليمية',
	},
};
